import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
  
   deleteOCTShortGame,
   fetchOCTShortGameShot,
   studentOCTShortGame,
   
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from '../../../oncoursetest/shortgame/component/addform';
import EditItem from '../../../oncoursetest/shortgame/component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class shortreport extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:true,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:this.props.data.student,
            sepmore:1,
            formValues: [{ shot:"", right : "", left : "", short : "", long : "", area:"", contact:"", putt : "", missedgreen : "0", disright:"", disleft:"", disshort:"", dislong:""}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
	   
	}

   onAddSession() {
		this.setState({ 
         listdiv:false,
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:true,
       });
	} 
   
   

   editAssessment(assmval){
        
      var id=assmval.gcr_userID;
      var date=assmval.gcr_date;
        
        this.props.fetchOCTShortGameShot(id, date).then((data) => {   
            var resdata=data.data;
            var troptobj=[];
            {resdata.map((teamval) => (   
               troptobj.push({
                  shot: teamval.gcr_shot,
                  right: teamval.gcr_right,
                  left: teamval.gcr_left,
                  short: teamval.gcr_short,
                  long: teamval.gcr_long,
                  area: teamval.gcr_area,
                  contact:teamval.gcr_contact,
                  putt: teamval.gcr_putt,
                  missedgreen:teamval.gcr_dhg,
                  disright:teamval.gcr_right==0 ? 0 : 1, 
                  disleft:teamval.gcr_left==0 ? 0 : 1, 
                  disshort:teamval.gcr_short==0 ? 0 : 1, 
                  dislong:teamval.gcr_long==0 ? 0 : 1,
               })
            ))} 
            this.setState({ 
               seldate:resdata[0].gcr_date, 
               student:resdata[0].gcr_userID,
               formValues:troptobj,
               sepmore:resdata.length
            });                  


            this.setState({ 
                listdiv:false,
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
            });

        });
    }

    deleteForm(assmval){
      this.id = assmval.gcr_userID;
      this.date = assmval.gcr_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteOCTShortGame(this.id, this.date);
            this.data = ""
        }
   }

   

    render() {
      const { match, octshortgamelist, loading } = this.props;
      
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            //{ name: "action1", label: "DELETE" },
          
        ];
        const tabledata=octshortgamelist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               //const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                //action1:dbtn,
                
                }
        }); 

       return (
        <div>
        <div className="col-md-12 col-lg-12 col-sm-12">
            <h1 className="text-center" style={{padding:"20px"}}> SHORT GAME TEST</h1>
        </div>
                                        
               {this.state.listdiv &&  
                <>
                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                        <div className="ddd">
                            <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><i className="zmdi ti-angle-double-left"></i>  Back To On Course</Button></div>
                            
                        </div>
                    </div>
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
                 </> 
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'short game test'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ octshortgame }) => {
	const { octshortgamelist, loading } = octshortgame;
	return { octshortgamelist, loading };
}

export default connect(mapStateToProps, {
   
   deleteOCTShortGame,
   fetchOCTShortGameShot,
   studentOCTShortGame,
   
})(shortreport); 